import * as types from './typeNames'
import axios from 'axios'
import { baseURL } from './base'
import LZString from 'lz-string'
import { FORM_VIEW } from './main'

export const getFormConfig = (FormId, PresId) => dispatch => {
    return axios.get(`${baseURL}/config/${FormId}`)
            .then(response => {
                if(response.data.status === 'success'){
                    let config = JSON.parse(LZString.decompressFromBase64(response.data.data))
                    if(config.design !== null && config.settings !== null){
                        addFonts(config.design)
                        dispatch(setConfig(config))
                        dispatch({type: types.SET_LOADER, view: FORM_VIEW, id: FormId, presId: PresId})
                    }                                        
                }else{
                    console.log(response.data); dispatch(() => ({type: "error", err: response.data}))
                }
            })
            .catch(err => {console.log(err); dispatch(() => ({type: "error", err})) })            
}

const setConfig = config => ({
    type: types.SET_CONFIG,
    config
})

const addFonts = design => {
    let fontStylesArr = []
    for(let prop in design.fonts){
        fontStylesArr.push(design.fonts[prop].font.cssImport)
    }
    let css = fontStylesArr.join('\n'),
    style = document.getElementById('emaze-fonts');
    style.type = 'text/css';
    if (style.styleSheet){
      // This is required for IE8 and below.
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }
}

export const onChangeCheckboxAction = (element_id, option_id) => ({
    type: types.CHANGE_CHECKBOX_OPTION,
    element_id,
    option_id
})

export const onDropdownChooseAction = (element_id, value) => ({
    type: types.DROPDOWN_CHOOSE_OPTION,
    element_id,
    value
})

export const onRadioChooseAction = (element_id, value) => ({
    type: types.RADIO_CHOOSE_OPTION,
    element_id,
    value
})

export const onTextChangeAction = (element_id, value) => ({
    type: types.TEXT_CHANGE,
    element_id,
    value
})

export const onDateChangeAction = (element_id, value) => ({
    type: types.DATE_CHANGE,
    element_id,
    value
})

export const onClickSubmitAction = (formId, presId, settings) => dispatch => {
    let elements = LZString.compressToBase64(JSON.stringify(settings.elements));
    let email = LZString.compressToBase64(settings.ownerEmail);
    let data = {
        FormId: formId,
        Title: settings.title,
        Elements: elements,
        PresentationId: presId,
        Email: email
    }
    return axios.post(`${baseURL}/submit`, data)
            .then(response => {
                if(response.data.status === 'success'){
                    //let config = JSON.parse(LZString.decompressFromBase64(response.data.data))
                    dispatch(onSubmitResponseAction(response.data.status, response.data.data))
                }else{
                    console.log(response.data); 
                    //dispatch(() => ({type: "error", err: response.data}))
                    dispatch(onSubmitResponseAction(response.data.status, response.data))
                }
            })
            .catch(err => {
                console.log(err); 
                //dispatch(() => ({type: "error", err})) 
                dispatch(onSubmitResponseAction('catch', err))
            })            
}

export const onSubmitResponseAction = (status, data) => ({
    type: types.ON_SUBMIT_RESPONSE,
    status,
    data
})